import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  },
  {},
);
